<template>
    <div class="CCcontent">
        <div style="background: #FFFFFF;width:100%">
            <Area width="1473" @changeSite="changeSite" @initAreaId="getInitAreaId" />
        </div>
        <div style="display: flex;flex-direction: column;justify-content: center;align-items: center;width:100%;height:100%"
            v-if="deviceList.length == 0">
            <img :src="require('../../assets/img/not_found_data.png')" alt="">
        </div>
        <div v-else class="itemContainer">
            <CapacitanceItems v-for="(item,index) in deviceList" :key="index" :device="item" />
        </div>
    </div>
</template>

<script>
    import Area from '../../components/OperatingEnvironment/Area';
    import CapacitanceItems from './CapacitanceItems'
    import {
        LowFeedDevice,
        DeviceLoop,
    } from "../../api/power"
    import {
        connect,
        destroyConnection,
        subscribebyLoopUrl,
        unsubscribebyLoopUrl
    } from '../../mqtt/loopdata'
    export default {
        name: "CapacitanceCompensation",
        components: {
            Area,
            CapacitanceItems,
        },
        data() {
            return {
                areaId: -1,
                deviceList: []
            }
        },
        created(){
            connect()
        },
        methods: {
            changeSite(areaId) {
                this.areaId = areaId;
                this.getLowFeedDevices()
            },
            getInitAreaId(areaId) {
                this.areaId = areaId;
                this.getLowFeedDevices()
            },
            async getLowFeedDevices() {
                let res = await LowFeedDevice(this.areaId)
                if (res.data.data.res) {
                    this.deviceList = res.data.data.res
                    this.deviceList.forEach(item => {
                        if (item.subLoopUrl)
                            subscribebyLoopUrl(item.subLoopUrl)
                    })
                }
            }
        },
        beforeDestroy() {
            this.deviceList.forEach(item => {
                if (item.subLoopUrl)
                    unsubscribebyLoopUrl(item.subLoopUrl)
            })
            destroyConnection()
        }
    };
</script>

<style lang="less" scoped>
    .CCcontent {
        .w(1600);
        .h(968);
    }

    .itemContainer {
        width: 100%;
        .h(885);
        overflow-y: scroll;

        // scrollbar-width: none;
    }

    // ::-webkit-scrollbar {
    //     display: none;
    // }
</style>